import httpClient from '../httpClient';

const contact = data => {
  return httpClient.post('support/contact', data);
};

export default {
  contact,
};
